const $$splitComponentImporter = () => import('/home/runner/work/inspecttec-frontend-admin/inspecttec-frontend-admin/src/routes/admin-roles/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { Permissions } from "@/constants/permissions";
import { requirePermission } from "@/lib/auth/permission-guard";
import { createFileRoute } from "@tanstack/react-router";
import { Trash2 } from "lucide-react";
export const Route = createFileRoute("/admin-roles/")({
  beforeLoad: args => requirePermission(Permissions.System.ManageRoles, args),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});